import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';

export const text = {
  dismissModalMessage: 'Proceed',
  lockExpirationTitle: 'Session Timeout',
  lockExpirationMessage:
    'You’ve been timed out due to inactivity. Your session for this model has expired.',
};

export const LockExpirationModal = ({
  buttonStyle,
  hasModelLockExpired,
  resetModelLockExpired,
}) =>
  hasModelLockExpired && (
    <div className={styles.lockExpirationModal}>
      <div className={styles.lockExpirationModalContent}>
        <h3 className={styles.title}>{text.lockExpirationTitle}</h3>
        <p className={styles.message}>{text.lockExpirationMessage}</p>
        <div className={styles.buttonContainer}>
          <button className={buttonStyle} onClick={resetModelLockExpired}>
            {text.dismissModalMessage}
          </button>
        </div>
      </div>
    </div>
  );

LockExpirationModal.propTypes = {
  buttonStyle: PropTypes.string.isRequired,
  hasModelLockExpired: PropTypes.bool.isRequired,
  resetModelLockExpired: PropTypes.func.isRequired,
};

export default enhance(LockExpirationModal);
